import { render, staticRenderFns } from "./BaseArticleVideoRow.vue?vue&type=template&id=65d9d0c0&"
import script from "./BaseArticleVideoRow.vue?vue&type=script&lang=js&"
export * from "./BaseArticleVideoRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseArticleVideoRow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports